import React from 'react';

export default function StatusIndicator({ status }) {
  return (
    <div className="status-indicator">
      <span className={`status-dot ${status.type}`}></span>
      <span className="status-text">{status.text}</span>
    </div>
  );
}

